export interface Card {
  readonly suit: 'hearts' | 'diamonds' | 'clubs' | 'spades',
  readonly color: 'red' | 'black',
  readonly rate: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13,
  readonly value: '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10' | 'jack' | 'queen' | 'king' | 'ace',
  readonly name: cardName,
  readonly number: number,
  readonly id: string,
  turned?: boolean,
}

export type cardName = 'hearts-2' | 'hearts-3' | 'hearts-4' | 'hearts-5' | 'hearts-6' | 'hearts-7' | 'hearts-8' |
  'hearts-9' | 'hearts-10' | 'hearts-jack' | 'hearts-queen' | 'hearts-king' | 'hearts-ace'|
  'diamonds-2' | 'diamonds-3' | 'diamonds-4' | 'diamonds-5' | 'diamonds-6' | 'diamonds-7' | 'diamonds-8' |
  'diamonds-9' | 'diamonds-10' | 'diamonds-jack' | 'diamonds-queen' | 'diamonds-king' | 'diamonds-ace' |
  'spades-2' | 'spades-3' | 'spades-4' | 'spades-5' | 'spades-6' | 'spades-7' | 'spades-8' |
  'spades-9' | 'spades-10' | 'spades-jack' | 'spades-queen' | 'spades-king' | 'spades-ace' |
  'clubs-2' | 'clubs-3' | 'clubs-4' | 'clubs-5' | 'clubs-6' | 'clubs-7' | 'clubs-8' |
  'clubs-9' | 'clubs-10' | 'clubs-jack' | 'clubs-queen' | 'clubs-king' | 'clubs-ace'
;

export type Deck = Card[];

const card_index: Deck = [
  {id: 'AC', number: 0, suit: 'clubs', color: 'black', value: 'ace', rate: 1, name: 'clubs-ace'},
  {id: 'AD', number: 1, suit: 'diamonds', color: 'red', value: 'ace', rate: 1, name: 'diamonds-ace'},
  {id: 'AH', number: 3, suit: 'hearts', color: 'red', value: 'ace', rate: 1, name: 'hearts-ace'},
  {id: 'AS', number: 2, suit: 'spades', color: 'black', value: 'ace', rate: 1, name: 'spades-ace'},

  {id: '2C', number: 4, suit: 'clubs', color: 'black', value: '2', rate: 2, name: 'clubs-2'},
  {id: '2D', number: 5, suit: 'diamonds', color: 'red', value: '2', rate: 2, name: 'diamonds-2'},
  {id: '2H', number: 7, suit: 'hearts', color: 'red', value: '2', rate: 2, name: 'hearts-2'},
  {id: '2S', number: 6, suit: 'spades', color: 'black', value: '2', rate: 2, name: 'spades-2'},

  {id: '3C', number: 8, suit: 'clubs', color: 'black', value: '3', rate: 3, name: 'clubs-3'},
  {id: '3D', number: 9, suit: 'diamonds', color: 'red', value: '3', rate: 3, name: 'diamonds-3'},
  {id: '3H', number: 11, suit: 'hearts', color: 'red', value: '3', rate: 3, name: 'hearts-3'},
  {id: '3S', number: 10, suit: 'spades', color: 'black', value: '3', rate: 3, name: 'spades-3'},

  {id: '4C', number: 12, suit: 'clubs', color: 'black', value: '4', rate: 4, name: 'clubs-4'},
  {id: '4D', number: 13, suit: 'diamonds', color: 'red', value: '4', rate: 4, name: 'diamonds-4'},
  {id: '4H', number: 15, suit: 'hearts', color: 'red', value: '4', rate: 4, name: 'hearts-4'},
  {id: '4S', number: 14, suit: 'spades', color: 'black', value: '4', rate: 4, name: 'spades-4'},

  {id: '5C', number: 16, suit: 'clubs', color: 'black', value: '5', rate: 5, name: 'clubs-5'},
  {id: '5D', number: 17, suit: 'diamonds', color: 'red', value: '5', rate: 5, name: 'diamonds-5'},
  {id: '5H', number: 18, suit: 'hearts', color: 'red', value: '5', rate: 5, name: 'hearts-5'},
  {id: '5S', number: 19, suit: 'spades', color: 'black', value: '5', rate: 5, name: 'spades-5'},

  {id: '6C', number: 20, suit: 'clubs', color: 'black', value: '6', rate: 6, name: 'clubs-6'},
  {id: '6D', number: 21, suit: 'diamonds', color: 'red', value: '6', rate: 6, name: 'diamonds-6'},
  {id: '6H', number: 22, suit: 'hearts', color: 'red', value: '6', rate: 6, name: 'hearts-6'},
  {id: '6S', number: 23, suit: 'spades', color: 'black', value: '6', rate: 6, name: 'spades-6'},

  {id: '7C', number: 24, suit: 'clubs', color: 'black', value: '7', rate: 7, name: 'clubs-7'},
  {id: '7D', number: 25, suit: 'diamonds', color: 'red', value: '7', rate: 7, name: 'diamonds-7'},
  {id: '7H', number: 26, suit: 'hearts', color: 'red', value: '7', rate: 7, name: 'hearts-7'},
  {id: '7S', number: 27, suit: 'spades', color: 'black', value: '7', rate: 7, name: 'spades-7'},

  {id: '8C', number: 28, suit: 'clubs', color: 'black', value: '8', rate: 8, name: 'clubs-8'},
  {id: '8D', number: 29, suit: 'diamonds', color: 'red', value: '8', rate: 8, name: 'diamonds-8'},
  {id: '8H', number: 30, suit: 'hearts', color: 'red', value: '8', rate: 8, name: 'hearts-8'},
  {id: '8S', number: 31, suit: 'spades', color: 'black', value: '8', rate: 8, name: 'spades-8'},

  {id: '9C', number: 32, suit: 'clubs', color: 'black', value: '9', rate: 9, name: 'clubs-9'},
  {id: '9D', number: 33, suit: 'diamonds', color: 'red', value: '9', rate: 9, name: 'diamonds-9'},
  {id: '9H', number: 34, suit: 'hearts', color: 'red', value: '9', rate: 9, name: 'hearts-9'},
  {id: '9S', number: 35, suit: 'spades', color: 'black', value: '9', rate: 9, name: 'spades-9'},

  {id: 'TC', number: 36, suit: 'clubs', color: 'black', value: '10', rate: 10, name: 'clubs-10'},
  {id: 'TD', number: 37, suit: 'diamonds', color: 'red', value: '10', rate: 10, name: 'diamonds-10'},
  {id: 'TH', number: 38, suit: 'hearts', color: 'red', value: '10', rate: 10, name: 'hearts-10'},
  {id: 'TS', number: 39, suit: 'spades', color: 'black', value: '10', rate: 10, name: 'spades-10'},

  {id: 'JC', number: 40, suit: 'clubs', color: 'black', value: 'jack', rate: 11, name: 'clubs-jack'},
  {id: 'JD', number: 41, suit: 'diamonds', color: 'red', value: 'jack', rate: 11, name: 'diamonds-jack'},
  {id: 'JH', number: 42, suit: 'hearts', color: 'red', value: 'jack', rate: 11, name: 'hearts-jack'},
  {id: 'JS', number: 43, suit: 'spades', color: 'black', value: 'jack', rate: 11, name: 'spades-jack'},

  {id: 'QC', number: 44, suit: 'clubs', color: 'black', value: 'queen', rate: 12, name: 'clubs-queen'},
  {id: 'QD', number: 45, suit: 'diamonds', color: 'red', value: 'queen', rate: 12, name: 'diamonds-queen'},
  {id: 'QH', number: 46, suit: 'hearts', color: 'red', value: 'queen', rate: 12, name: 'hearts-queen'},
  {id: 'QS', number: 47, suit: 'spades', color: 'black', value: 'queen', rate: 12, name: 'spades-queen'},

  {id: 'KC', number: 48, suit: 'clubs', color: 'black', value: 'king', rate: 13, name: 'clubs-king'},
  {id: 'KD', number: 49, suit: 'diamonds', color: 'red', value: 'king', rate: 13, name: 'diamonds-king'},
  {id: 'KH', number: 50, suit: 'hearts', color: 'red', value: 'king', rate: 13, name: 'hearts-king'},
  {id: 'KS', number: 51, suit: 'spades', color: 'black', value: 'king', rate: 13, name: 'spades-king'},






];

export default card_index;
